import React, { useCallback, useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import ClipLoader from "react-spinners/ClipLoader";

import SpecialistsTab from "../results/SpecialistsTab";
import PracticesTab from "../results/PracticesTab";
import MentorshipsTab from "../results/MentorshipsTab";
import PromtoursTab from "../results/PromtoursTab";

import { fetchWrapper } from "@helpers/fetchwrapper";

import styles from "./styles/addition.module.css";

const SPECIALISTS_TAB = "5";
const PROMTOURS_TAB = "3";
const CAREER_CENTER_TAB = "4";
const CAREER_CENTER_PAGE_TYPE = 8;

function getInitialTab() {
  const params = new URLSearchParams(window.location.search);
  const tab = params.get("tab");

  if (tab === "specialists") {
    return SPECIALISTS_TAB;
  }

  if (tab === "promtours") {
    return PROMTOURS_TAB;
  }

  if (tab === "career-center") {
    return CAREER_CENTER_TAB;
  }

  return SPECIALISTS_TAB;
}

function Addition({ data }) {
  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [specialists, setSpecialists] = useState({
    data: [],
    total: 0,
  });
  const [practices, setPractices] = useState({
    data: [],
    total: 0,
  });
  const [mentorships, setMentorships] = useState({
    data: [],
    total: 0,
  });
  const [promtours, setPromtours] = useState({
    data: [],
    total: 0,
  });
  const [careerCenterContent, setCareerCenterContent] = useState(null);
  const [loadCareerCenter, setLoadCareerCenter] = useState(false);
  const [limit] = useState(8);
  const [loadData, setLoadData] = useState(false);

  const loadCareerCenterPage = useCallback(() => {
    setLoadCareerCenter(true);
    setCareerCenterContent(null);
    fetchWrapper
      .get(
        `/v1/api/app/companyPage?company=${data.Id}&type=${CAREER_CENTER_PAGE_TYPE}`
      )
      .then((res) => {
        setCareerCenterContent(res);
      })
      .finally(() => {
        setLoadCareerCenter(false);
      });
  }, [data.Id]);

    const loadSpecialists = useCallback(
    (offset) => {
      setLoadData(true);
      fetchWrapper
        .get(
          `/v1/api/app/GetSpecialistNeedsByCompanyId?offset=${offset}&limit=${limit}&idCompany=${data.Id}`
        )
        .then((res) => {
          setSpecialists({
            data: res.data || [],
            total: res.total || res.Total || 0,
          });
        })
        .finally(() => {
          setLoadData(false);
        });
    },
    [data, limit]
  );

  const loadPractices = useCallback(
    (offset) => {
      setLoadData(true);
      fetchWrapper
        .get(
          `/v1/api/app/getPracticyByIdCompany?idCompany=${data.Id}&limit=${limit}&offset=${offset}`
        )
        .then((res) => {
          setPractices(res);
        })
        .finally(() => {
          setLoadData(false);
        });
    },
    [data, limit]
  );

  const loadMentorships = useCallback(
    (offset) => {
      setLoadData(true);
      fetchWrapper
        .get(
          `/v1/api/app/getMentorshipsByCompanyId?idCompany=${data.Id}&limit=${limit}&offset=${offset}`
        )
        .then((res) => {
          setMentorships(res);
        })
        .finally(() => {
          setLoadData(false);
        });
    },
    [data, limit]
  );

  const loadPromtours = useCallback(
    (offset) => {
      setLoadData(true);
      fetchWrapper
        .get(
          `/v1/api/app/GetCompanyPromtoursByCompanyId?idCompany=${data.Id}&limit=${limit}&offset=${offset}`
        )
        .then((res) => {
          setPromtours({
            data: res.data || [],
            total: res.total || 0,
          });
        })
        .finally(() => {
          setLoadData(false);
        });
    },
    [data, limit]
  );

    useEffect(() => {
    const initialTab = getInitialTab();

    if (initialTab === SPECIALISTS_TAB) {
      loadSpecialists(0);
      return;
    }

    if (initialTab === PROMTOURS_TAB) {
      loadPromtours(0);
      return;
    }

    if (initialTab === CAREER_CENTER_TAB) {
      loadCareerCenterPage();
      return;
    }

    loadPractices(0);
  }, [
    loadSpecialists,
    loadPractices,
    loadPromtours,
    loadCareerCenterPage,
  ]);

  const renderCareerCenterTab = () => (
    <div className={styles.tabContent}>
      {loadCareerCenter ? (
        <div className="d-flex justify-content-center w-100">
          <ClipLoader />
        </div>
      ) : careerCenterContent ? (
        <div dangerouslySetInnerHTML={{ __html: careerCenterContent.Body }} />
      ) : (
        "Страница не найдена"
      )}
    </div>
  );

  return (
        <div className={`${styles.block} container`}>
      <Nav tabs className={styles.tabs}>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${
              activeTab === SPECIALISTS_TAB ? styles.active : null
            }`}
            onClick={() => {
              loadSpecialists(0);
              setActiveTab(SPECIALISTS_TAB);
            }}
          >
            СПЕЦИАЛИСТЫ
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${
              activeTab === "1" ? styles.active : null
            }`}
            onClick={() => {
              loadPractices(0);
              setActiveTab("1");
            }}
          >
            ПРАКТИКИ
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${
              activeTab === "2" ? styles.active : null
            }`}
            onClick={() => {
              loadMentorships(0);
              setActiveTab("2");
            }}
          >
            НАСТАВНИКИ
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${
              activeTab === PROMTOURS_TAB ? styles.active : null
            }`}
            onClick={() => {
              loadPromtours(0);
              setActiveTab(PROMTOURS_TAB);
            }}
          >
            ПРОФТУРЫ
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={`${styles.tab} ${
              activeTab === CAREER_CENTER_TAB ? styles.active : null
            }`}
            onClick={() => {
              loadCareerCenterPage();
              setActiveTab(CAREER_CENTER_TAB);
            }}
          >
            ЦЕНТР КАРЬЕРЫ
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={SPECIALISTS_TAB}>
            <SpecialistsTab
              load={loadData}
              results={specialists}
              limit={limit}
              onChangePage={loadSpecialists}
            />
          </TabPane>
          <TabPane tabId="1">
            <PracticesTab
              load={loadData}
              results={practices}
              limit={limit}
              companyId={data.Id}
              onChangePage={loadPractices}
            />
          </TabPane>
          <TabPane tabId="2">
            <MentorshipsTab
              load={loadData}
              results={mentorships}
              limit={limit}
              companyId={data.Id}
              onChangePage={loadMentorships}
            />
          </TabPane>
          <TabPane tabId={PROMTOURS_TAB}>
            <PromtoursTab
              load={loadData}
              results={promtours}
              limit={limit}
              onChangePage={loadPromtours}
            />
          </TabPane>
          <TabPane tabId={CAREER_CENTER_TAB}>
            {renderCareerCenterTab()}
          </TabPane>
        </TabContent>
      </TabContent>
    </div>
  );
}

export default Addition;
